import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import tw, { theme } from 'twin.macro'
import { useTranslation } from 'react-i18next'
import { SearchIcon } from '@components/Icons'
import { SEARCH_BAR_INPUT_MAX_LENGTH } from '../searchConstant'

interface SearchBarProps {
  onSearch?: (keyword: string) => void
  value?: string
}

export default function SearchBar(props: SearchBarProps) {
  const { value, onSearch } = props
  const [inputValue, setInputValue] = useState(value)
  const inputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation('search')

  // FIXME: e 會是 ChangeEvent<HTMLInputElement> | CompositionEvent<HTMLInputElement>
  // 但不管我怎麼寫 type check 沒過
  const handleOnChange = (e: any) => {
    const nextInputValue = e.target.value.slice(0, SEARCH_BAR_INPUT_MAX_LENGTH)
    setInputValue(nextInputValue)
    if (!e.nativeEvent.isComposing) onSearch(nextInputValue)
  }

  useEffect(() => {
    if (inputRef.current.value === '') inputRef.current.focus()
  }, [])

  // 如果點擊熱門搜尋， input 要強制更改
  useEffect(() => {
    if (value === inputValue || document.activeElement === inputRef.current) return
    setInputValue(value)
  }, [value])

  return (
    <Container>
      <StyledSearchIcon />
      <StyledForm action="/search" onSubmit={(e) => e.preventDefault()} target="_top">
        <StyledInput
          type="search"
          name="keyword"
          value={inputValue || ''}
          placeholder={t(['searchBar.placeholder', '女孩們都在搜尋「美妝」'])}
          onChange={handleOnChange}
          onCompositionEnd={handleOnChange}
          autoComplete="off"
          ref={inputRef}
        />
      </StyledForm>
    </Container>
  )
}

const Container = styled.div`
  ${tw`flex w-full items-center`}
  padding: 0 8px;
  height: 56px;
  border-bottom: 1px solid #999999;
`

const StyledSearchIcon = styled(SearchIcon)`
  ${tw`text-gray-600`}
  width: 20px;
  height: 20px;
`

const StyledForm = styled.form`
  ${tw`w-full`}
  margin-left: 12px;
`

const StyledInput = styled.input`
  ${tw`border-0 outline-none block w-full bg-transparent`}
  ${tw`text-gray-800 placeholder-gray-200 leading-h3-d`}
  caret-color: ${theme`colors.primary.indigo`};
  font-size: 20px;
  /* input type="search" 的內建 cancel button */
  ::-webkit-search-cancel-button {
    height: 16px;
    width: 16px;
    -webkit-appearance: none;
    background: url(/images/search/closeIcon.svg) no-repeat 50% 50%;
    background-size: cover;
    cursor: pointer;
  }
`
